import { createFileRoute } from "@tanstack/react-router";

import { parseListsSearch } from "@/features/catalog";
import { ListsPage } from "@/features/catalog/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/catalog/lists")({
  validateSearch: strictSearch(parseListsSearch),
  component: Lists,
});

function Lists() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <ListsPage search={search} onSearchChange={(next) => void navigate({ search: next })} />;
}
